
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Product, UsageRecord } from "@/lib/types";

interface UsageByProductChartProps {
  groupProducts: Product[];
  usageRecords: UsageRecord[];
  timeRange: "7days" | "30days" | "90days";
}

const UsageByProductChart = ({ 
  groupProducts, 
  usageRecords, 
  timeRange 
}: UsageByProductChartProps) => {
  // Calculate total usage by product in the group
  const usageByProduct = groupProducts.map(product => {
    const productUsage = usageRecords
      .filter(record => record.productId === product.id)
      .reduce((sum, record) => sum + record.quantity, 0);
    
    return {
      name: product.name,
      usage: productUsage
    };
  }).sort((a, b) => b.usage - a.usage); // Sort by usage, highest first

  return (
    <Card>
      <CardHeader>
        <CardTitle>Usage by Product in Group</CardTitle>
        <CardDescription>
          Total usage for each product in this group during {timeRange === "7days" ? "the last 7 days" : 
            timeRange === "30days" ? "the last 30 days" : "the last 90 days"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={usageByProduct}
              margin={{ top: 5, right: 30, left: 20, bottom: 50 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="usage" name="Usage" fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default UsageByProductChart;
